import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ContactsIcon from '@mui/icons-material/ContactsOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import InsightsIcon from '@mui/icons-material/InsightsOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import PoolIcon from '@mui/icons-material/PoolOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import RuleOutlinedIcon from '@mui/icons-material/RuleOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import WorkIcon from '@mui/icons-material/WorkOutlineOutlined';
import WorkspacesIcon from '@mui/icons-material/WorkspacesOutlined';
import { AppModules } from '@/types';
import { Role } from '@/types/api';
import { Paths, ServiceDefinition, SidebarOptionType } from '@/types/routes';

// --- Sidebar menu items ---

const candidatesMenuItem: SidebarOptionType = {
  path: Paths.CANDIDATES,
  label: 'Candidates',
  icon: ContactsIcon,
};

const challengesMenuItem: SidebarOptionType = {
  path: Paths.CHALLENGES,
  label: 'Challenges',
  icon: EmojiEventsIcon,
};

const challengeReviewersMenuItem: SidebarOptionType = {
  path: Paths.CHALLENGES_REVIEWERS,
  label: 'Reviewers',
  icon: GroupOutlinedIcon,
};

const talentPoolMenuItem: SidebarOptionType = {
  path: Paths.TALENT_POOL,
  label: 'Talent Pool',
  icon: PoolIcon,
};

const reportsMenuItem: SidebarOptionType = {
  path: Paths.REPORTS,
  label: 'Reports',
  icon: InsightsIcon,
};

const jobsMenuItem: SidebarOptionType = {
  path: Paths.JOBS,
  label: 'Jobs',
  icon: WorkIcon,
};

const seminarsMenuItem: SidebarOptionType = {
  path: Paths.SEMINARS,
  label: 'Seminars',
  icon: OndemandVideoIcon,
};

const teamMembersMenuItem: SidebarOptionType = {
  path: Paths.STAFF,
  label: 'Staff',
  icon: GroupOutlinedIcon,
};

export const teamsMenuItem: SidebarOptionType = {
  path: Paths.TEAMS,
  label: 'Teams',
  icon: WorkspacesIcon,
};

const ptoRequestsMenuItem: SidebarOptionType = {
  path: Paths.PTO_REQUESTS,
  label: 'PTO Requests',
  icon: BeachAccessIcon,
};

const usersManagementMenuItem: SidebarOptionType = {
  path: Paths.SETTINGS_USERS,
  label: 'Users',
  icon: ManageAccountsOutlinedIcon,
};

const permissionsMenuItem: SidebarOptionType = {
  path: Paths.SETTINGS_PERMISSIONS,
  label: 'Permissions',
  icon: AdminPanelSettingsOutlinedIcon,
};

const integrationsMenuItem: SidebarOptionType = {
  path: Paths.SETTINGS_INTEGRATIONS,
  label: 'Integrations',
  icon: IntegrationInstructionsOutlinedIcon,
};

// --- Service definitions ---

const homeService: ServiceDefinition = {
  id: AppModules.HOME,
  name: 'Home',
  description: 'Dashboard & overview',
  icon: HomeOutlinedIcon,
  color: '#054ad9',
  basePath: '/home',
  sidebarMenus: [],
};

const talentXService: ServiceDefinition = {
  id: AppModules.TALENTX,
  name: 'TalentX',
  description: 'Recruitment & hiring pipeline',
  icon: TravelExploreIcon,
  color: '#f2a654',
  basePath: '/talentx',
  sidebarMenus: [
    candidatesMenuItem,
    challengesMenuItem,
    challengeReviewersMenuItem,
    reportsMenuItem,
    talentPoolMenuItem,
    jobsMenuItem,
  ],
};

const peopleXService: ServiceDefinition = {
  id: AppModules.PEOPLEX,
  name: 'PeopleX',
  description: 'HR management & employee operations',
  icon: PersonPinOutlinedIcon,
  color: '#2AD062',
  basePath: '/peoplex',
  sidebarMenus: [teamMembersMenuItem, teamsMenuItem, ptoRequestsMenuItem],
  adminOnly: true,
};

const academyService: ServiceDefinition = {
  id: AppModules.TRIO_ACADEMY,
  name: 'Academy',
  description: 'Learning & development',
  icon: SchoolOutlinedIcon,
  color: '#655CC1',
  basePath: '/academy',
  sidebarMenus: [seminarsMenuItem],
};

// --- SEOx sidebar menu items ---
// These are static defaults; inside a project, PageLayout generates dynamic paths with projectId.

const seoProjectsMenuItem: SidebarOptionType = {
  path: Paths.SEOX_PROJECTS,
  label: 'Projects',
  icon: TrendingUpOutlinedIcon,
};

const seoxService: ServiceDefinition = {
  id: AppModules.SEOX,
  name: 'SEOx',
  description: 'SEO intelligence & growth automation',
  icon: TrendingUpOutlinedIcon,
  color: '#054AD9',
  basePath: '/seox',
  landingPath: '/seox',
  sidebarMenus: [seoProjectsMenuItem],
};

// --- FinanceX sidebar menu items ---

const fxDashboardMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_DASHBOARD,
  label: 'Dashboard',
  icon: DashboardOutlinedIcon,
};

const fxBankAccountsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_BANK_ACCOUNTS,
  label: 'Bank Accounts',
  icon: AccountBalanceOutlinedIcon,
};

const fxClientsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_CLIENTS,
  label: 'Client Profitability',
  icon: BusinessOutlinedIcon,
};

const fxVendorsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_VENDORS,
  label: 'Vendors',
  icon: StoreOutlinedIcon,
};

const fxSubscriptionsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_SUBSCRIPTIONS,
  label: 'Subscriptions',
  icon: AutorenewIcon,
};

const fxTransactionsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_TRANSACTIONS,
  label: 'Transactions',
  icon: ReceiptLongOutlinedIcon,
};

const fxReviewMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_REVIEW,
  label: 'Review Queue',
  icon: FactCheckOutlinedIcon,
};

const fxImportMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_IMPORT,
  label: 'Import',
  icon: UploadFileOutlinedIcon,
};

const fxInvoicesMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_INVOICES,
  label: 'Invoices',
  icon: DescriptionOutlinedIcon,
};

const fxRulesMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_RULES,
  label: 'Rules',
  icon: RuleOutlinedIcon,
};

const fxPnlMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_PNL,
  label: 'Monthly P&L',
  icon: ShowChartOutlinedIcon,
};

const fxContractorsMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_CONTRACTORS,
  label: 'Contractors',
  icon: PeopleAltOutlinedIcon,
};

const fxPayrollMenuItem: SidebarOptionType = {
  path: Paths.FINANCEX_PAYROLL,
  label: 'Payroll Reports',
  icon: PaymentsOutlinedIcon,
};

const financeXService: ServiceDefinition = {
  id: AppModules.FINANCEX,
  name: 'FinanceX',
  description: 'Spend management & vendor tracking',
  icon: AccountBalanceWalletOutlinedIcon,
  color: '#10B981',
  basePath: '/financex',
  landingPath: '/financex',
  sidebarMenus: [
    fxDashboardMenuItem,
    fxPnlMenuItem,
    fxContractorsMenuItem,
    fxPayrollMenuItem,
    fxClientsMenuItem,
    fxInvoicesMenuItem,
    fxBankAccountsMenuItem,
    fxVendorsMenuItem,
    fxSubscriptionsMenuItem,
    fxTransactionsMenuItem,
    fxReviewMenuItem,
    fxImportMenuItem,
    fxRulesMenuItem,
  ],
};

// --- CEOx ---

const ceoxDashboardMenuItem: SidebarOptionType = {
  path: Paths.CEOX_DASHBOARD,
  label: 'Scorecard',
  icon: AssessmentOutlinedIcon,
};

const ceoxPipelineMenuItem: SidebarOptionType = {
  path: Paths.CEOX_PIPELINE,
  label: 'Pipeline',
  icon: TimelineOutlinedIcon,
};

const ceoxColdEmailMenuItem: SidebarOptionType = {
  path: Paths.CEOX_COLD_EMAIL,
  label: 'Cold Email',
  icon: EmailOutlinedIcon,
};

const ceoxSEOMenuItem: SidebarOptionType = {
  path: Paths.CEOX_SEO,
  label: 'SEO',
  icon: TrendingUpOutlinedIcon,
};

const ceoxGoogleAdsMenuItem: SidebarOptionType = {
  path: Paths.CEOX_GOOGLE_ADS,
  label: 'Google Ads',
  icon: CampaignOutlinedIcon,
};

const ceoxSettingsMenuItem: SidebarOptionType = {
  path: Paths.CEOX_SETTINGS,
  label: 'Settings',
  icon: SettingsOutlinedIcon,
};

const ceoxService: ServiceDefinition = {
  id: AppModules.CEOX,
  name: 'CEOx',
  description: 'CEO dashboard & KPIs',
  icon: AssessmentOutlinedIcon,
  color: '#7C3AED',
  basePath: '/ceox',
  sidebarMenus: [
    ceoxDashboardMenuItem,
    ceoxPipelineMenuItem,
    ceoxColdEmailMenuItem,
    ceoxSEOMenuItem,
    ceoxGoogleAdsMenuItem,
    ceoxSettingsMenuItem,
  ],
};

/** Build dynamic CEOx sidebar based on the org's business stack */
export function getCeoxSidebarMenus(
  stack: {
    crm: { provider: string; isActive: boolean } | null;
    email: { provider: string; isActive: boolean } | null;
    ads: { provider: string; isActive: boolean } | null;
    seo: { provider: string; isActive: boolean } | null;
  } | null
): SidebarOptionType[] {
  const menus: SidebarOptionType[] = [ceoxDashboardMenuItem];

  const isActive = (entry: { provider: string; isActive: boolean } | null): boolean =>
    !!entry && entry.provider !== 'none' && entry.isActive;

  if (isActive(stack?.crm ?? null)) menus.push(ceoxPipelineMenuItem);
  if (isActive(stack?.email ?? null)) menus.push(ceoxColdEmailMenuItem);
  if (isActive(stack?.seo ?? null)) menus.push(ceoxSEOMenuItem);
  if (isActive(stack?.ads ?? null)) menus.push(ceoxGoogleAdsMenuItem);

  menus.push(ceoxSettingsMenuItem);
  return menus;
}

const settingsService: ServiceDefinition = {
  id: AppModules.SETTINGS,
  name: 'Settings',
  description: 'System configuration & users',
  icon: ManageAccountsOutlinedIcon,
  color: '#96979b',
  basePath: '/settings',
  sidebarMenus: [usersManagementMenuItem, permissionsMenuItem, integrationsMenuItem],
};

export const services: ServiceDefinition[] = [
  homeService,
  talentXService,
  peopleXService,
  academyService,
  seoxService,
  financeXService,
  ceoxService,
];

export const settingsServices: ServiceDefinition[] = [settingsService];

// --- Accessor functions ---

const doesSidebarExistInPermissions = (
  sidebar: SidebarOptionType,
  userPermissions: string[]
): boolean => {
  // Check new path
  const artifact = `web:${sidebar.path}`;
  if (userPermissions.includes(artifact)) return true;

  // Also check legacy paths for backwards compatibility
  const legacyPath = sidebar.path.replace('/talentx/', '/hiring/').replace('/peoplex/', '/people/');
  const legacyArtifact = `web:${legacyPath}`;
  return userPermissions.includes(legacyArtifact);
};

export function getAccessibleServices(roles: Role[]): ServiceDefinition[] {
  if (!roles) return [];

  let userPermissions: string[] = [];
  roles.forEach((role) => {
    const rolePermissionValues = role.permissions.map((p) => p.value);
    userPermissions = [...userPermissions, ...rolePermissionValues];
  });

  return services
    .map((service) => {
      const allowedSidebarMenus = service.sidebarMenus.filter((sidebar) =>
        doesSidebarExistInPermissions(sidebar, userPermissions)
      );
      return { ...service, sidebarMenus: allowedSidebarMenus };
    })
    .filter(
      (service) =>
        service.sidebarMenus.length > 0 ||
        service.id === AppModules.HOME ||
        service.id === AppModules.TALENTX ||
        service.id === AppModules.PEOPLEX ||
        service.id === AppModules.TRIO_ACADEMY ||
        service.id === AppModules.SEOX ||
        service.id === AppModules.FINANCEX ||
        service.id === AppModules.CEOX
    );
}

export function getServiceByPath(pathname: string): ServiceDefinition | undefined {
  // Check all services (including settings) for path match
  const allServices = [...services, ...settingsServices];

  for (const service of allServices) {
    if (service.id === AppModules.HOME && pathname.startsWith('/home')) {
      return service;
    }
    if (service.basePath !== '/home' && pathname.startsWith(service.basePath)) {
      return service;
    }
    // Check if any sidebar menu path matches
    for (const menu of service.sidebarMenus) {
      const menuBase = menu.path.split('/:')[0]; // strip params
      if (pathname.startsWith(menuBase)) {
        return service;
      }
    }
  }

  // Fallback: check legacy paths
  if (pathname.startsWith('/hiring')) {
    return talentXService;
  }
  if (pathname.startsWith('/people')) {
    return peopleXService;
  }
  if (pathname.startsWith('/growthx')) {
    return seoxService;
  }

  return homeService;
}

export function getServiceById(moduleId: AppModules): ServiceDefinition | undefined {
  const allServices = [...services, ...settingsServices];
  return allServices.find((s) => s.id === moduleId);
}
